var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeClosedIcon = function SvgEyeClosedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m3 3 14 14M10.5 10.5q-.6.6-1.5.6c-1.4 0-2.6-1-2.6-2.2q0-.9.6-1.5M15.7 12.2c1.4-1.3 2.4-3.1 2.4-3.1s-2.5-5-8.1-5c-1.3 0-2.4.3-3.4.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M1.9 6.1c-.5 1-.8 2-.8 3s3.3 6 8.9 6c1.4 0 2.7-.4 3.8-1"
  })));
};
export default SvgEyeClosedIcon;